var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 19.7778C5.4962 19.7853 5.00965 19.5943 4.64541 19.2462C4.4361 19.0413 4.27088 18.7958 4.15989 18.5247C4.04891 18.2537 3.9945 17.9628 4.00001 17.67V9.74997C3.99904 9.43737 4.07203 9.12897 4.21301 8.84997C4.34973 8.57295 4.55106 8.33287 4.80001 8.14997L10.8 4.62217C10.9751 4.49318 11.1691 4.39198 11.375 4.32217C11.781 4.18883 12.219 4.18883 12.625 4.32217C12.831 4.39198 13.025 4.49317 13.2001 4.62217L19.2001 8.14997C19.4496 8.33263 19.6513 8.57275 19.7881 8.84997C19.9291 9.12893 20.0018 9.43741 20.0001 9.74997V17.6679C20.0057 17.9612 19.9513 18.2525 19.8402 18.524C19.7291 18.7956 19.5637 19.0415 19.3541 19.2468C18.9902 19.595 18.5037 19.7858 18.0001 19.7778H14.69C14.507 19.7778 14.3315 19.7051 14.2021 19.5757C14.0727 19.4463 14 19.2708 14 19.0878V14.44C14 14.257 13.9273 14.0815 13.7979 13.9521C13.6685 13.8227 13.493 13.75 13.31 13.75H10.69C10.507 13.75 10.3315 13.8227 10.2021 13.9521C10.0727 14.0815 10 14.257 10 14.44V19.0886C10 19.1792 9.98217 19.2689 9.94749 19.3526C9.91282 19.4363 9.86199 19.5124 9.79792 19.5765C9.73385 19.6405 9.65778 19.6914 9.57407 19.726C9.49035 19.7607 9.40063 19.7786 9.31001 19.7786L6.00001 19.7778Z",
    fill: "#BD161D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_99",
    x1: 15.5,
    y1: 4.99997,
    x2: 12.0001,
    y2: 19.7786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C01519"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/homeActive.fd31da6855b65e1140f632110d7cebf1.svg";
export { ForwardRef as ReactComponent };